import { PlacementSelector } from "../types/placement";

export function findTemplate<T extends { type: string; platform?: string | null; placementType?: string | null }>(
  items: T[],
  selector: PlacementSelector
): T | undefined {
  if (selector.kind === "placement") {
    return items.find((item) => item.platform === selector.platform && item.placementType === selector.placementType);
  }

  return items.find((item) => item.type === selector.aspectRatio);
}

export function hasTemplate<T extends { type: string; platform?: string | null; placementType?: string | null }>(
  items: T[],
  selector: PlacementSelector
): boolean {
  return findTemplate(items, selector) !== undefined;
}
